// extracted by mini-css-extract-plugin
module.exports = {"container":"NewsSection_container__R5H0k","news":"NewsSection_news__CUf3E","card":"NewsSection_card__kugoa","button":"NewsSection_button__uFTgh"};